import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { IFeedback } from "../Interfaces/IFeedback";
import { IBook } from "../Interfaces/IBook";
import { checkExistingFeedback, givenFeedbackIsDown, givenFeedbackIsUp } from "../lib/Functions";
import {oneMonthInSeconds, getCookie, setCookie} from "../lib/Constants"
import { checkUser } from "../services/AIpen";
import { ICON_BUTTON } from "../lib/A11y";
interface CustomBook {
    book: IBook;
    givenFeedback: IFeedback[];
    feedbackSetter: any;
    showModal: Function;
}

const FaqFeedback = ({ book, givenFeedback, feedbackSetter, showModal }: CustomBook): JSX.Element => {

    const { setJobIDFeedback, setFeedback, setAlreadyDone, setRank } = feedbackSetter;
    
    const selectedFeedback: IFeedback | false = checkExistingFeedback(book.aipenJobsInfo.idFaq, givenFeedback);

    const onClickFaqFeedback = async (value: boolean) => {
        const userCheckedCookie = getCookie("user_on_aipen");
        if((userCheckedCookie && userCheckedCookie === "false") || !userCheckedCookie) {
            const checkUserRes = await checkUser();
            if (checkUserRes.status) {
                setCookie("user_on_aipen", "true", oneMonthInSeconds);
            }
        }
        setJobIDFeedback(book.aipenJobsInfo.idFaq);
        setFeedback(true);
        setAlreadyDone(selectedFeedback);
        setRank(selectedFeedback ? selectedFeedback.vote : value);
        showModal(false);
    }

    return (
        <div className="flex gap-2">
            <button aria-label="Valuta positivamente le FAQ" aria-pressed={selectedFeedback !== false && selectedFeedback.vote}
                className={`${ICON_BUTTON} mt-1`} onClick={() => onClickFaqFeedback(true)} type="button">
                <FontAwesomeIcon aria-hidden="true" icon={faThumbsUp} className={`h-6 ${givenFeedbackIsUp(selectedFeedback)}`}/>
            </button>
            <button aria-label="Valuta negativamente le FAQ" aria-pressed={selectedFeedback !== false && !selectedFeedback.vote}
                className={`${ICON_BUTTON} mt-2`} onClick={() => onClickFaqFeedback(false)} type="button">
                <FontAwesomeIcon aria-hidden="true" icon={faThumbsDown} className={`h-6 ${givenFeedbackIsDown(selectedFeedback)}`}/>
            </button>
        </div>
    );
};

export default FaqFeedback;
